module.exports = __webpack_public_path__ + "img/product-kind.f0f89ee9.jpg";